var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faCaretDown, faExternalLinkAlt, faEye, faFileExport, faStar, faTrash, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { getGalaxyInstance } from "@/app";
import { deleteWorkflow, updateWorkflow } from "@/components/Workflow/workflows.services";
import { useConfirmDialog } from "@/composables/confirmDialog";
import { Toast } from "@/composables/toast";
import { useUserStore } from "@/stores/userStore";
import AsyncButton from "@/components/Common/AsyncButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowActions',
    props: {
        workflow: null,
        menu: { type: Boolean },
        published: { type: Boolean },
        buttonSize: { default: "sm" }
    },
    emits: ["refreshList", "toggleShowPreview"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretDown, faExternalLinkAlt, faEye, faFileExport, farStar, faStar, faTrash);
        const userStore = useUserStore();
        const { isAnonymous } = storeToRefs(userStore);
        const { confirm } = useConfirmDialog();
        const shared = computed(() => {
            if (userStore.currentUser) {
                return userStore.currentUser.username !== props.workflow.owner;
            }
            else {
                return false;
            }
        });
        const sourceType = computed(() => {
            var _a, _b, _c;
            if ((_a = props.workflow.source_metadata) === null || _a === void 0 ? void 0 : _a.url) {
                return "url";
            }
            else if ((_b = props.workflow.source_metadata) === null || _b === void 0 ? void 0 : _b.trs_server) {
                return `trs_${(_c = props.workflow.source_metadata) === null || _c === void 0 ? void 0 : _c.trs_server}`;
            }
            else {
                return "";
            }
        });
        function onToggleBookmark(checked) {
            return __awaiter(this, void 0, void 0, function* () {
                yield updateWorkflow(props.workflow.id, {
                    show_in_tool_panel: checked,
                });
                emit("refreshList", true);
                Toast.info(`Workflow ${checked ? "added to" : "removed from"} bookmarks`);
                if (checked) {
                    getGalaxyInstance().config.stored_workflow_menu_entries.push({
                        id: props.workflow.id,
                        name: props.workflow.name,
                    });
                }
                else {
                    const indexToRemove = getGalaxyInstance().config.stored_workflow_menu_entries.findIndex((w) => w.id === props.workflow.id);
                    getGalaxyInstance().config.stored_workflow_menu_entries.splice(indexToRemove, 1);
                }
            });
        }
        function onDelete() {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmed = yield confirm("Are you sure you want to delete this workflow?", {
                    title: "Delete workflow",
                    okTitle: "Delete",
                    okVariant: "danger",
                });
                if (confirmed) {
                    yield deleteWorkflow(props.workflow.id);
                    emit("refreshList", true);
                    Toast.info("Workflow deleted");
                }
            });
        }
        const actions = computed(() => {
            return [
                {
                    condition: !props.workflow.deleted && !props.workflow.show_in_tool_panel,
                    class: "workflow-bookmark-button-add",
                    component: "async",
                    title: "Add bookmarks",
                    tooltip: "Add to bookmarks. This workflow will appear in the left tool panel.",
                    icon: farStar,
                    size: props.buttonSize,
                    variant: "link",
                    action: () => onToggleBookmark(true),
                },
                {
                    condition: !props.workflow.deleted && props.workflow.show_in_tool_panel,
                    class: "workflow-bookmark-button-remove",
                    component: "async",
                    title: "Remove bookmark",
                    tooltip: "Remove bookmark",
                    icon: faStar,
                    size: props.buttonSize,
                    variant: "link",
                    action: () => onToggleBookmark(false),
                },
                {
                    condition: true,
                    class: "workflow-view-button",
                    component: "button",
                    title: "View workflow",
                    tooltip: "View workflow",
                    icon: faEye,
                    size: props.buttonSize,
                    variant: "link",
                    onClick: () => emit("toggleShowPreview", true),
                },
            ];
        });
        const menuActions = computed(() => {
            var _a, _b, _c, _d, _e;
            return [
                {
                    condition: !isAnonymous.value && !shared.value && !props.workflow.deleted,
                    class: "workflow-delete-button",
                    component: "button",
                    title: "Delete workflow",
                    tooltip: "Delete workflow",
                    icon: faTrash,
                    size: props.buttonSize,
                    variant: "link",
                    onClick: () => onDelete(),
                },
                {
                    condition: sourceType.value.includes("trs"),
                    class: "source-trs-button",
                    component: "button",
                    title: `View on ${(_a = props.workflow.source_metadata) === null || _a === void 0 ? void 0 : _a.trs_server}`,
                    href: `https://dockstore.org/workflows${(_d = (_c = (_b = props.workflow) === null || _b === void 0 ? void 0 : _b.source_metadata) === null || _c === void 0 ? void 0 : _c.trs_tool_id) === null || _d === void 0 ? void 0 : _d.slice(9)}`,
                    target: "_blank",
                    icon: faExternalLinkAlt,
                    size: props.buttonSize,
                    variant: "link",
                },
                {
                    condition: sourceType.value == "url",
                    class: "workflow-view-external-link-button",
                    component: "button",
                    title: "View external link",
                    href: (_e = props.workflow.source_metadata) === null || _e === void 0 ? void 0 : _e.url,
                    target: "_blank",
                    icon: faExternalLinkAlt,
                    size: props.buttonSize,
                    variant: "link",
                },
                {
                    condition: !props.workflow.deleted,
                    class: "workflow-export-button",
                    component: "button",
                    title: "Export",
                    icon: faFileExport,
                    size: props.buttonSize,
                    variant: "link",
                    to: `/workflows/export?id=${props.workflow.id}`,
                },
            ];
        });
        return { __sfc: true, props, emit, userStore, isAnonymous, confirm, shared, sourceType, onToggleBookmark, onDelete, actions, menuActions, faCaretDown, FontAwesomeIcon, BButton, AsyncButton };
    }
});
